import { Result, TrimValidationFields, backendApi } from "./backendApi";

export interface VinModel {
  vin?: string;
}

class GetVinsRequest {
  recId?: number;
}

class GetVinsResponse {
  vins?: VinModel[];
}

class CreateVinRequest {
  recId?: number;
  vin?: VinModel;
}

class UpdateVinRequest {
  recId?: number;
  originalVin?: string;
  vin?: VinModel;
}

class DeleteVinRequest {
  recId?: number;
  vin?: VinModel;
}

export const vinAPI = {
  async getVins(recId: number): Promise<Result<VinModel[]>> {
    let response = await backendApi.sendAndGetResponseAsync<GetVinsResponse>(
      "GetVins",
      { recId: recId } as GetVinsRequest,
    );

    if (response.ok) {
      return { ok: true, value: response.value.vins ?? [] };
    }

    return response;
  },

  async createVin(recId: number, vin: VinModel): Promise<Result<any>> {
    let response = await backendApi.sendAsync("CreateVin", {
      recId: recId,
      vin: vin,
    } as CreateVinRequest);

    if (response.ok) {
      return { ok: true, value: "" };
    }

    TrimValidationFields(response.problem, "Vins");

    return response;
  },

  async updateVin(
    recId: number,
    originalVin: string,
    vin: VinModel,
  ): Promise<Result<any>> {
    let response = await backendApi.sendAsync("UpdateVin", {
      recId: recId,
      originalVin: originalVin,
      vin: vin,
    } as UpdateVinRequest);

    if (response.ok) {
      return { ok: true, value: "" };
    }

    TrimValidationFields(response.problem, "Vin");

    return response;
  },

  async deleteVin(recId: number, vin: VinModel): Promise<Result<any>> {
    let response = await backendApi.sendAsync("DeleteVin", {
      recId: recId,
      vin: vin,
    } as DeleteVinRequest);

    if (response.ok) {
      return { ok: true, value: "" };
    }

    TrimValidationFields(response.problem, "Vin");

    return response;
  },
};
